import React, { FC } from 'react';
import { Container, Form } from 'react-bootstrap';
import { CollectionResponseDto } from '../../../store/landscapeAPI/collection/dto/response/collection-response.dto';
import { Button, RadioButton } from '../../atoms';
import styles from './ReportingDetailsCollectionsForm.module.css';
import { ImageUploader } from '../../molecules';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

interface ReportingDetailsCollectionsFormProps {
  data: CollectionResponseDto;
  callbackFn: (goal: CollectionResponseDto) => void;
  handleOnChange: (goal: CollectionResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
}

const ReportingDetailsCollectionsForm: FC<
  ReportingDetailsCollectionsFormProps
> = ({ data, callbackFn, handleOnChange, handleImageOnChange }) => {
  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    callbackFn(data);
  };

  return (
    <Container className={styles.form}>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            value={data.name}
            onChange={(e) =>
              handleOnChange({
                ...data,
                name: e.target.value,
              })
            }
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <ImageUploader
            setImage={(e) => {
              handleOnChange({ ...data, icon: e });
            }}
            imageSrc={data.icon ?? undefined}
            id={data.id}
            setImageMeta={(imageMeta) => handleImageOnChange(imageMeta)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Is Published</Form.Label>
          <br />
          <RadioButton
            defaultChecked={data.published}
            onChange={(checked) =>
              handleOnChange({
                ...data,
                published: checked,
              })
            }
          />
        </Form.Group>
        <Button variant={'dark'} onClick={handleSubmit}>
          Save
        </Button>
      </Form>
    </Container>
  );
};

export default ReportingDetailsCollectionsForm;
